import { fmtDate, money } from "../api";
import { useLang, useT } from "../i18n";
import { SC } from "../scenes";
import { Head, Plate, useApi, useShell } from "../ui";
import type { Trip } from "./Home";

const STATE: Record<string, string> = { draft: "Draft", sent: "Proposal sent", viewed: "Proposal opened", accepted: "Booked", expired: "Expired" };

/** Trips (docs/37 §1): the pipeline as cards, planning to travelling. */
export function Trips() {
  const t = useT();
  const lang = useLang();
  const { go, ask } = useShell();
  const { data } = useApi<{ trips: Trip[] }>("/trips");
  const trips = data?.trips ?? [];
  return (
    <>
      <Head eyebrow={t("trips.eyebrow")} title={t("nav.trips")} extra={<button className="btn ink" type="button" onClick={() => go("builder")}>{t("trips.new")}</button>} />
      <div className="pipeline" style={{ marginBottom: "1.2rem" }}>{(["planning", "booking", "travel_ready", "travelling"] as const).map((s) => <div key={s}><span>{t(`stage.${s}`)}</span><b>{trips.filter((x) => x.stage === s).length}</b></div>)}</div>
      {trips.length ? (
        <div className="grid" data-testid="trips">{trips.map((x) => (
          <article key={x.id} className="pk"><Plate svg={SC.forCat("City Break")} /><div className="b">
            <span className="cat">{STATE[x.state] ?? x.state} · {t(`stage.${x.stage}`)}{x.client ? ` · ${x.client.name}` : ""}</span>
            <h4>{x.title}</h4>
            <p className="loc">{t("common.travellers", { n: x.travellers.adults + x.travellers.childAges.length })} · {fmtDate(x.departDate, lang)} · {x.orderReference ?? x.reference}</p>
            <div className="foot"><div className="price"><small>{t("trips.client")}</small><b>{money(x.totals.clientTotalMinor, x.currency)}</b>{x.totals.agentEarnsMinor !== undefined ? <small className="mg"> · you earn {money(x.totals.agentEarnsMinor, x.currency)}</small> : null}</div>
              <div className="actions">{x.proposalToken ? <a className="btn ink" href={`/proposal/${x.proposalToken}`} target="_blank" rel="noopener">{t("trips.proposal")}</a> : null}<button className="btn line" type="button" onClick={() => ask("Write the proposal text for my client for this quote.", x.id)}>Ask AI</button></div></div>
          </div></article>
        ))}</div>
      ) : <div className="card empty"><b>{t("trips.none")}</b></div>}
    </>
  );
}
